import type { AxiosRequestConfig } from 'axios'
import qs from 'qs'

import { QS_CONFIG } from '../../constants/api'
import { getPublicAuth } from '../getPublicAuth'
import { decryptUser } from '../user'

export async function addCredentialsToRequest(
  request: AxiosRequestConfig<string | FormData | undefined>,
) {
  const user = decryptUser()
  const lang = localStorage.getItem('i18nextLng') ?? 'es'
  const privateAuth = localStorage.getItem('privateAuth')

  if (request.data instanceof FormData) {
    const auth = request.data.get('auth')
    const username = request.data.get('username')
    const password = request.data.get('password')

    if (!auth) {
      if (privateAuth) {
        request.data.append('auth', privateAuth)
      } else {
        const publicAuth = await getPublicAuth()
        request.data.append('auth', publicAuth)
      }
    }

    // ISSUE: When QS_CONFIG has encode: false, special characters like +, &, =, % in user credentials
    // get misinterpreted during qs.stringify() and qs.parse() operations. For example:
    // - Username "user+name" becomes "user name" (space instead of +)
    // - Password "pass=word" breaks key-value parsing
    // - Characters like & and % can cause query string parsing errors
    //
    // FIX: By stringifying and then parsing the user object with QS_CONFIG, we ensure
    // that any special characters are properly handled according to the encoding rules,
    // preventing data corruption when credentials are added to FormData.
    const userStringified = qs.stringify(user, QS_CONFIG)
    const parsedUser = qs.parse(userStringified, QS_CONFIG) as Record<
      string,
      string
    >

    if (!username && parsedUser?.username) {
      request.data.append('username', parsedUser?.username)
    }

    if (!password && parsedUser?.password) {
      request.data.append('password', parsedUser?.password)
    }
    
    if (lang === 'zh') {
      request.data.append('language', '1')
    }
  } else if (typeof request.data === 'string') {
    let requestData = qs.parse(request.data)
    const { auth, username, password } = requestData

    if (!auth) {
      if (privateAuth) {
        requestData = { ...requestData, auth: privateAuth }
      } else {
        const publicAuth = await getPublicAuth()
        requestData = { ...requestData, auth: publicAuth }
      }
    }

    if (!username && user?.username)
      requestData = { ...requestData, username: user?.username }

    if (!password && user?.password)
      requestData = { ...requestData, password: user?.password }

    if (lang === 'zh') {
      requestData = { ...requestData, language: '1' }
    }

    const updatedRequestDataQueryString = qs.stringify(requestData, QS_CONFIG)

    request.data = updatedRequestDataQueryString
  }

  return request
}
